import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 供应链端消息类型
 */
class MsgNotifyType extends UltMeta {
    All = new Meta(0, "全部");
    MESSAGE_TYPE_CONTRACT = new Meta(6, "合同");
    MESSAGE_TYPE_ORDER = new Meta(1, "订单");
    MESSAGE_TYPE_FUNDING = new Meta(8, "资金");
    MESSAGE_TYPE_INVENTORY = new Meta(12, "仓储");
    MESSAGE_TYPE_NOTICE = new Meta(13, "公告");
    MESSAGE_TYPE_OTHER = new Meta(2, "其他");
}
export const MSG_NOTIFY_TYPE = new MsgNotifyType();

/**
 * 小程序 供应链端 消息类型
 */
class WxMsgNotifyType extends UltMeta {
    All = new Meta(0, "全部");
    // MESSAGE_TYPE_CONTRACT = new Meta(6, "合同");
    // MESSAGE_TYPE_ORDER = new Meta(1, "订单");
    // MESSAGE_TYPE_FUNDING = new Meta(8, "资金");
    MESSAGE_TYPE_INVENTORY = new Meta(12, "仓储");
    MESSAGE_TYPE_NOTICE = new Meta(13, "公告");
    MESSAGE_TYPE_OTHER = new Meta(2, "其他");
}
export const WX_MSG_NOTIFY_TYPE = new WxMsgNotifyType();

// 银行端消息类型
class BankMsgNotifyType extends UltMeta {
    All = new Meta(0, "全部");
    MESSAGE_TYPE_LOAN_RECEIPT = new Meta(10, "贷款");
    MESSAGE_TYPE_REPAYMENT = new Meta(11, "还款");
}
export const BANK_MSG_NOTIFY_TYPE = new BankMsgNotifyType();
